import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import * as Actions from '../../store/scan-to-print/scan-to-print.actions';
import style from './scan-layout.module.less';

export const ScanPageLayout = ({ renderHeader, renderBody }) => {
  const dispatch = useDispatch();
  const isHeaderFocused = useSelector(Global.selectScanToPrintIsHeaderFocused);
  const setScanHeaderFocus = useCallback((inactive) => dispatch(Actions.setScanHeaderFocus(inactive)), [dispatch]);

  return (
    <div className={style['scan-page']}>
      <div>{renderHeader && renderHeader()}</div>
      <div className={style.body}>{renderBody && renderBody(isHeaderFocused, setScanHeaderFocus)}</div>
    </div>
  );
};

ScanPageLayout.propTypes = {
  renderHeader: PropTypes.func,
  renderBody: PropTypes.func,
};
